import "core-js/modules/es.array.push.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import { reactive, ref } from "vue";
import { ElMessage } from "element-plus";
import apis from "@/api";
import { ACCESS_TOKEN, USERINFO } from "@/store/mutation-types";
import { access, encryption } from "@/utils/aesEncrypt";
import { useRouter } from "vue-router";
export default {
  __name: 'ResetPwd',
  emits: ['success', 'update:visible'],
  setup(__props, {
    emit: __emit
  }) {
    const router = useRouter();
    const emits = __emit;
    const ruleForm = ref();
    const data = reactive({
      account: {
        originPwd: '',
        newPwd: '',
        repeatNewPwd: ''
      }
    });
    const rules = {
      originPwd: [{
        required: true,
        message: '请输入原密码',
        trigger: 'blur'
      }, {
        type: 'string',
        pattern: /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[a-zA-Z0-9~!@&%#_+-]{8,16}$/,
        message: '密码格式错误！',
        trigger: 'blur'
      }],
      newPwd: [{
        required: true,
        message: '请输入新密码',
        trigger: 'blur'
      }, {
        type: 'string',
        pattern: /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[a-zA-Z0-9~!@&%#_+-]{8,16}$/,
        message: '密码格式错误！',
        trigger: 'blur'
      }],
      repeatNewPwd: [{
        required: true,
        message: '请再次输入新密码',
        trigger: 'blur'
      }, {
        type: 'string',
        pattern: /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[a-zA-Z0-9~!@&%#_+-]{8,16}$/,
        message: '密码格式错误！',
        trigger: 'blur'
      }]
    };
    const onSubmit = async ruleForm => {
      await ruleForm.validate(valid => {
        if (valid) {
          if (data.account.newPwd !== data.account.repeatNewPwd) {
            ElMessage.error('两次新密码输入不一致!');
            return;
          }
          if (data.account.newPwd === data.account.originPwd) {
            ElMessage.error('新旧密码不能相同!');
            return;
          }
          apis.resetPwd({
            password: encryption(data.account.originPwd, access.key, access.iv),
            newPassword: encryption(data.account.newPwd, access.key, access.iv)
          }).then(res => {
            if (res.success) {
              emits('success');
              ElMessage.success("修改成功！请重新登录！");
              apis.logout().then(res => {
                if (res.success) {
                  window.localStorage.removeItem(ACCESS_TOKEN);
                  window.localStorage.removeItem(USERINFO);
                } else {
                  ElMessage.error(res.msg);
                }
              }).finally(() => {
                router.push("/login");
                window.location.reload();
              });
            } else {
              ElMessage.error(res.msg);
            }
          });
        } else {
          return false;
        }
      });
    };
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_tooltip = _resolveComponent("el-tooltip");
      const _component_el_form = _resolveComponent("el-form");
      return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_el_form, {
        ref_key: "ruleForm",
        ref: ruleForm,
        model: data.account,
        rules: rules,
        style: {
          "width": "100%"
        }
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          label: "原密码：",
          prop: "originPwd"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: data.account.originPwd,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => data.account.originPwd = $event),
            placeholder: "请输入原密码",
            "show-password": ""
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "新密码：",
          prop: "newPwd"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: data.account.newPwd,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => data.account.newPwd = $event),
            placeholder: "请输入新密码",
            "show-password": ""
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "再次输入：",
          prop: "repeatNewPwd"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: data.account.repeatNewPwd,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => data.account.repeatNewPwd = $event),
            placeholder: "请再次输入新密码",
            "show-password": ""
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_tooltip, {
          class: "item",
          effect: "dark",
          content: "密码至少包含一个大写字母、小写字母和数字，长度为8到16位，仅支持~!@&%#_+-特殊字符。",
          placement: "top-start"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_button, {
            type: "text",
            style: {
              "display": "flex",
              "float": "right"
            }
          }, {
            default: _withCtx(() => [...(_cache[4] || (_cache[4] = [_createTextVNode("密码格式", -1)]))]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [_createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[3] || (_cache[3] = $event => onSubmit(ruleForm.value))
          }, {
            default: _withCtx(() => [...(_cache[5] || (_cache[5] = [_createTextVNode("提交", -1)]))]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }, 8, ["model"])]);
    };
  }
};